{
  "accountScreen": {
    "downloadCta": "Descargar documento firmado",
    "helpDescription": "Envíenos un correo a <underline>{{email}}</underline>",
    "helpTitle": "¿Necesita ayuda o tiene preguntas?",
    "loggedInWith": "Sesión iniciada con {{method}}",
    "title": "Cuenta",
    "usernameLoginMethod": "Nombre de usuario"
  },
  "addHouseholdMemberScreen": {
    "addAnother": "Agregar a otro",
    "addingMemberDescription": "Queremos saber quiénes viven con usted.",
    "addingMemberTitle": "Cuéntenos sobre ellos",
    "age": "Edad",
    "coverageCheck": {
      "dateOfBirth": "Fecha de nacimiento (opcional)",
      "description": "Opcional. Esto nos ayuda a buscar si ya tienen cobertura.",
      "medicaidId": "ID de Medicaid (opcional)",
      "medicaidIdPlaceholder": "Ingrese el ID de Medicaid",
      "ssn": "Seguro Social (opcional)",
      "ssnPlaceholder": "XXX-XX-XXXX",
      "title": "Ayúdenos a ver su cobertura"
    },
    "duplicateDialog": {
      "cancel": "No, volver",
      "checkError": "No pudimos verificar los miembros de tu hogar. Por favor, intenta de nuevo.",
      "confirm": "Sí, es otra persona",
      "description": "Ya agregaste a <bold>{{name}}</bold>. ¿La persona que estás agregando ahora es alguien diferente?",
      "descriptionWithDetails": "Ya agregaste a <bold>{{name}}</bold> ({{details}}). ¿La persona que estás agregando ahora es alguien diferente?",
      "reminder": "No necesitas volver a agregar a alguien que ya agregaste.",
      "title": "¿Es alguien nuevo?"
    },
    "enterDateOfBirth": "Usar fecha de nacimiento",
    "enterRelationship": "Poner relación",
    "firstName": "Nombre",
    "formSubmission": {
      "error": "No pudimos agregar a ese miembro de la familia. Por favor, intenta de nuevo.",
      "success": "Se agregó a {{firstName}} correctamente"
    },
    "lastName": "Apellido",
    "livingWithMe": "Vive conmigo",
    "relationshipToMe": "Relación conmigo",
    "sameMailingAddress": "Misma dirección de correo",
    "updateFormSubmission": {
      "success": "Se actualizó a {{firstName}} correctamente"
    },
    "validations": {
      "ageOrDateOfBirthRequired": "Por favor, escribe tu edad o tu fecha de nacimiento.",
      "futureDateOfBirth": "Por favor, ingrese una fecha de nacimiento correspondiente a hoy o a una fecha anterior.",
      "invalidDateOfBirth": "Por favor, escribe una fecha de nacimiento válida (mes/día/año).",
      "selectAnOption": "Por favor, elige una opción.",
      "specifyRelationship": "Por favor, dinos qué parentesco tiene esta persona contigo."
    }
  },
  "appFooter": {
    "partnershipLabel": "En colaboración con"
  },
  "appHeader": {
    "toggleThemeTooltip": "El cambio de tema es para pruebas internas."
  },
  "appMenu": {
    "account": "Cuenta",
    "household": "Hogar",
    "language": "Idioma",
    "logout": "Salir"
  },
  "applicantDocuments": {
    "alsoCompleted": "Este documento también completó {{section}}.",
    "alsoCompletedResidenceForMembers": "Este documento también completó {{section}} para los miembros del hogar que viven en la misma dirección",
    "deleteDialog": {
      "description": "¿Seguro que quiere borrar este papel? No podrá recuperarlo después.",
      "title": "Borrar documento"
    },
    "deleteToast": {
      "error": "No pudimos borrar ese documento. Por favor, intenta de nuevo.",
      "success": "Documento borrado correctamente"
    },
    "immigrationIncomplete": {
      "description": "Todavía necesita subir un ID de USCIS, papeles de inmigración o un I-20 para completar {{section}}.",
      "dismiss": "Entendido",
      "title": "Falta un documento más"
    },
    "optional": "Opcional",
    "progress": "{{completeCount}} de {{applicableCount}} completados",
    "selectDocumentType": "Elegir tipo de documento",
    "ssn": {
      "cardOption": "O suba su tarjeta de Seguro Social",
      "label": "Número de Seguro Social",
      "save": "Guardar",
      "saveError": "No pudimos guardar ese número. Por favor, intenta de nuevo.",
      "saved": "Número de Seguro Social guardado"
    },
    "supportedFiles": "Tipos permitidos: PDF, JPG, PNG",
    "upload": {
      "failed": "No se pudo subir este documento. Por favor, intenta de nuevo.",
      "failedDescription": "No pudimos leer este archivo. Por favor, quítalo y sube uno nuevo.",
      "uploading": "Subiendo..."
    },
    "uploadOne": "Suba <bold>al menos uno:</bold>"
  },
  "applicationAddressScreen": {
    "description": "Por favor, revise y confirme la dirección de cada persona de su hogar.",
    "homeAddress": "Dirección de casa",
    "isHomeless": "Sin dirección fija",
    "mailingAddress": "Dirección de correo",
    "needsHomeAddress": "<italic>Falta dirección de casa</italic>",
    "needsMailingAddress": "<italic>Falta dirección de correo</italic>",
    "noMailingAddress": "Sin dirección de correo",
    "sameHomeAddress": "Misma dirección de casa",
    "sameMailingAddress": "Misma dirección de correo",
    "title": "Información de dirección",
    "updateHouseholdAddressesDialog": {
      "addressTypeHome": "dirección de casa",
      "addressTypeHomeAndMailing": "dirección de casa y correo",
      "addressTypeMailing": "dirección de correo",
      "description_one": "{{householdName}} y {{count}} otro actualmente comparten su {{addressType}}. ¿Desea actualizar la de ellos también?",
      "description_other": "{{householdName}} y {{count}} otros actualmente comparten su {{addressType}}. ¿Desea actualizar la de ellos también?",
      "description_zero": "{{householdName}} actualmente comparte su {{addressType}}. ¿Desea actualizar la de ellos también?",
      "onlyUpdateMine": "No, solo actualizar la mía",
      "title": "Actualizar direcciones del hogar",
      "updateMembers_one": "Actualizar {{count}} miembro",
      "updateMembers_other": "Actualizar {{count}} miembros"
    },
    "you": "{{name}} (Usted)"
  },
  "applicationChildCaregiverStatusScreen": {
    "description": "Los niños deben <bold>vivir con el miembro del hogar</bold> por <bold>más de medio año</bold> y el miembro del hogar debe <bold>pagar más de la mitad</bold> de sus <bold>gastos anuales</bold> (comida, casa, escuela y médicos). Esto incluye a parientes no consanguíneos.",
    "title": "¿Viven estos miembros con algún niño menor de 19 años y lo cuidan?"
  },
  "applicationCitizenshipStatusScreen": {
    "description": "¿Son <bold>{{householdMembersNames}}</bold> todos ciudadanos de EE. UU.?",
    "hintDescription": "Si marca <bold>No</bold>, no se preocupe. Hay otras opciones para calificar según su estado migratorio.",
    "noDescription": "Algunos o todos no son ciudadanos",
    "title": "Elegibilidad",
    "yesDescription": "Todos son ciudadanos de EE. UU."
  },
  "applicationConfirmationScreen": {
    "brokerDeclined": {
      "description": "Seleccione “Sí, conéctame” para recibir ayuda y mantener a sus médicos y cubrir a su familia en un solo lugar.",
      "summaryWithMedicaid": "Revisaremos su solicitud de Medicaid y nos comunicaremos con usted si necesitamos algo. Aún necesitará un agente de seguros licenciado para completar su inscripción en {{programs}}.",
      "summaryWithoutMedicaid": "Ya tenemos lo que envió. Aún necesitará un agente de seguros licenciado para completar su inscripción en {{programs}}.",
      "title": "Eligió no conectarse con un agente de seguros licenciado. ¿Está seguro?"
    },
    "continueButton": "Continuar",
    "description": "Nuestro equipo revisará sus solicitudes y se comunicará con usted si necesitamos algo. Cuando todo esté en orden, las enviaremos a los programas que eligió.",
    "title": "¡Recibimos sus solicitudes!"
  },
  "applicationCoverageStatusScreen": {
    "description": "¿Tienen <bold>{{householdMembersNames}}</bold> algún seguro o cobertura de salud? Incluya la cobertura que comenzará pronto.",
    "noDescription": "Nadie tiene cobertura",
    "pleaseSpecify": "Por favor, detalle",
    "title": "Estado de la cobertura",
    "whatType": "¿Qué tipo de cobertura?",
    "who": "¿Quién tiene cobertura?",
    "yesDescription": "Alguien tiene cobertura"
  },
  "applicationDateOfBirthScreen": {
    "description": "Por favor, agregue y confirme la fecha de todos en el hogar",
    "success": "Se guardaron las fechas de nacimiento",
    "title": "Fecha de nacimiento"
  },
  "applicationDocuments": {
    "description": "Usaremos estos papeles para confirmar sus datos. Puede subirlos ahora o volver después.",
    "title": "Subir documentos"
  },
  "applicationExpensesScreen": {
    "addAnotherExpense": "Agregar otro gasto",
    "addExpense": "Agregar gasto",
    "description": "Agregue gastos médicos o deducibles de cada persona.",
    "expenseTypes": {
      "ALIMONY_PAID": "Pensión pagada a ex-pareja",
      "CHILDCARE": "Cuidado de niños",
      "IRA_CONTRIBUTIONS": "Aportes a cuenta IRA",
      "MEDICAL_EXPENSES": "Gastos médicos",
      "MOVING_EXPENSES": "Gastos de mudanza",
      "NONE": "Ninguno",
      "OTHER": "Otro",
      "STUDENT_LOANS": "Préstamos estudiantiles",
      "TUITION_FEES": "Matrícula y cuotas"
    },
    "memberDialog": {
      "alertDescriptions": {
        "MEDICAL_EXPENSES": "Después le pediremos una prueba de este gasto. Tenga a mano facturas médicas o recibos de farmacia.",
        "OTHER": "Después le pediremos una prueba de este gasto.",
        "STUDENT_LOANS": "Después le pediremos una prueba de este gasto. Tenga a mano cartas de préstamos o de la escuela."
      },
      "medicalExpenses3MonthsHelpNeededStatus": "¿Tiene gastos médicos de los últimos 3 meses que necesite ayuda para pagar?",
      "title": "Elija un gasto"
    },
    "monthlyExpense": "{{monthlyExpense}} / mes",
    "progress": "Progreso: {{progress}} de {{total}} listo",
    "title": "Gastos del hogar"
  },
  "applicationFlow": {
    "amountPerMonth": "Cantidad al mes"
  },
  "applicationForm": {
    "applyingToCounter": "Aplicando a {{programsCount}} para {{householdMembersCount}} personas",
    "continueButton": "Continuar a solicitudes",
    "greatNews": "¡Buenas noticias!",
    "letsCreateApplications": "Vamos a crear las solicitudes para todos.",
    "mayBeEligible": "<bold>{{names}}</bold> podrían calificar",
    "mayBeEligibleFor": "{{memberNames}} podrían calificar para <bold>{{brand}}</bold>",
    "notEligible": "No califican por ahora",
    "programConflictDialog": {
      "description": "Solicitar {{newProgram}} eliminará la solicitud de {{currentPrograms}} de {{memberNames}}. {{memberNames}} no puede solicitar ambos al mismo tiempo. Cuando envíes tu solicitud, nos aseguraremos de que {{memberNames}} esté en el programa correcto.",
      "description_members": "Solicitar {{newProgram}} eliminará las solicitudes de {{currentPrograms}} de {{memberNames}}. {{memberNames}} no pueden solicitar ambos al mismo tiempo. Cuando envíes tu solicitud, nos aseguraremos de que {{memberNames}} estén en el programa correcto.",
      "description_self": "Solicitar {{newProgram}} eliminará tu solicitud de {{currentPrograms}}. No puedes solicitar ambos al mismo tiempo. Cuando envíes tu solicitud, nos aseguraremos de que estés en el programa correcto.",
      "keepButton": "Mantener {{currentPrograms}}",
      "multipleDescription": "Solicitar {{newProgram}} eliminará las solicitudes de {{currentPrograms}} de {{memberNames}}. {{memberNames}} no puede solicitarlos todos al mismo tiempo. Cuando envíes tu solicitud, nos aseguraremos de que {{memberNames}} esté en el programa correcto.",
      "multipleDescription_members": "Solicitar {{newProgram}} eliminará las solicitudes de {{currentPrograms}} de {{memberNames}}. {{memberNames}} no pueden solicitarlos todos al mismo tiempo. Cuando envíes tu solicitud, nos aseguraremos de que {{memberNames}} estén en el programa correcto.",
      "multipleDescription_self": "Solicitar {{newProgram}} eliminará tus solicitudes de {{currentPrograms}}. No puedes solicitarlos todos al mismo tiempo. Cuando envíes tu solicitud, nos aseguraremos de que estés en el programa correcto.",
      "recommendMedicaidDescription": "{{memberNames}} no puede solicitar ambos al mismo tiempo. Medicaid es gratuito y {{memberNames}} califica para él. Cuando envíes tu solicitud, nos aseguraremos de que {{memberNames}} esté en el programa correcto.",
      "recommendMedicaidDescription_members": "{{memberNames}} no pueden solicitar ambos al mismo tiempo. Medicaid es gratuito y {{memberNames}} califican para él. Cuando envíes tu solicitud, nos aseguraremos de que {{memberNames}} estén en el programa correcto.",
      "recommendMedicaidDescription_self": "No puedes solicitar ambos al mismo tiempo. Medicaid es gratuito y calificas para él. Cuando envíes tu solicitud, nos aseguraremos de que estés en el programa correcto.",
      "recommendMedicaidTitle": "Te recomendamos solicitar Medicaid",
      "switchButton": "Cambiar a {{newProgram}}",
      "title": "Solo puedes solicitar un programa"
    },
    "programsFound": "Encontramos {{programsCount}} programas para los {{householdMembersCount}} miembros del hogar.",
    "recentDuplicateDialog": {
      "continueAnyway": "Continuar de todos modos",
      "description": "Recientemente enviaste una solicitud de <bold>{{applicationType}}</bold> para {{memberNames}}. Solo debes enviar otra solicitud si algo ha cambiado.",
      "multipleDescription": "Recientemente enviaste solicitudes de <bold>{{applicationTypes}}</bold> para {{memberNames}}. Solo debes enviar otra solicitud si algo ha cambiado.",
      "title": "Enviaste una solicitud recientemente"
    },
    "startButton": "Iniciar solicitudes"
  },
  "applicationMaritalStatusScreen": {
    "description": "Pusimos el estado civil según la información del hogar. Revise y cambie si es necesario.",
    "needsMaritalStatus": "Falta el estado civil",
    "title": "Estado civil actual"
  },
  "applicationOtherStatusesScreen": {
    "conditions": {
      "americanIndianOrAlaskaNative": "Indígena americano o nativo de Alaska",
      "needsHelpDailyActivities": "Necesita ayuda con tareas diarias",
      "studentFullTime18to20": "Estudiante de tiempo completo (18-20 años)",
      "veteranOrMilitaryMember": "Veterano o militar"
    },
    "description": "Marque cualquier situación que aplique a los miembros del hogar.",
    "errors": {
      "unableToUpdateHouseholdMembers": "No pudimos guardar esos cambios. Por favor, intenta de nuevo."
    },
    "title": "Otros estados"
  },
  "applicationSection": {
    "applications": "Solicitudes",
    "beginYourApplicationCompact": "Aplique en 15 minutos o menos",
    "beginYourApplicationProcess": "Inicie su proceso y obtenga cobertura en 15 minutos o menos",
    "continueQuickApply": "Continuar Aplicación Rápida",
    "continueYourApplicationCompact": "Siga con su solicitud",
    "continueYourApplicationProcess": "Siga con su proceso y obtenga cobertura en 15 minutos o menos",
    "newQuickApply": "Nueva Aplicación Rápida",
    "quickApply": "Aplicación Rápida"
  },
  "applicationSubmitScreen": {
    "description": "Ya completó todos los pasos. Cuando esté listo, envíe sus solicitudes a continuación.",
    "hintMessage": "No podrá hacer cambios después de enviar, así que revise que todo esté bien.",
    "partialFailure": "Es posible que algunas de tus solicitudes no se hayan enviado. Por favor, revísalas en tu lista de solicitudes.",
    "submitButton": "Enviar solicitudes",
    "success": "Solicitudes enviadas correctamente.",
    "title": "¡Todo listo!"
  },
  "applicationTaxInformationScreen": {
    "description": "Según lo que nos contó, esto es lo que creemos sobre sus impuestos. Revise y actualice si hace falta.",
    "errors": {
      "unableToUpdateRelationship": "No pudimos actualizar ese parentesco. Por favor, intenta de nuevo."
    },
    "memberCard": {
      "dependentOf": "Dependiente de: {{name}}",
      "dependents": "Dependientes: {{name}}",
      "memberDialog": {
        "description": "Revise y cambie los datos de impuestos de esta persona si es necesario.",
        "saveAndReturn": "Guardar y volver",
        "taxClaimedAsDependentStatus": "¿Alguien pondrá a esta persona como dependiente?",
        "taxDependentsClaimedStatus": "¿Esta persona pondrá a alguien como dependiente?",
        "taxFilingStatus": "Estado de impuestos",
        "title": "Impuestos – {{name}}",
        "who": "¿Quién?"
      }
    },
    "needsTaxInformation": "Necesita datos de impuestos",
    "success": "Datos de impuestos actualizados",
    "title": "Información de impuestos"
  },
  "applicationWorkAndIncomeScreen": {
    "addAnotherIncome": "Agregar otro ingreso",
    "addIncome": "Agregar ingreso",
    "description": "Agregue el trabajo e ingresos de cada miembro del hogar.",
    "incomeTypes": {
      "ALIMONY": "Pensión de ex-pareja",
      "EMPLOYED": "Empleado",
      "NONE": "Ninguno",
      "OTHER": "Otro",
      "PENSION": "Pensión",
      "PROPERTY_RENTAL_INCOME": "Ingreso por renta de propiedad",
      "RETIREMENT_INCOME": "Ingreso de jubilación",
      "SELF_EMPLOYED": "Trabajador independiente",
      "SSA": "Seguro Social (SSA)",
      "SSDI": "Seguro de Discapacidad (SSDI)",
      "UNEMPLOYED": "Desempleado",
      "WORKERS_COMPENSATION": "Compensación laboral"
    },
    "memberDialog": {
      "alertDescriptions": {
        "EMPLOYED": "Después pediremos una prueba de este ingreso. Tenga listos sus talones de pago o W-2.",
        "OTHER": "Después pediremos una prueba de este ingreso. Tenga a mano cartas de beneficios.",
        "SELF_EMPLOYED": "Después pediremos una prueba de este ingreso. Tenga a mano facturas o formularios 1099.",
        "UNEMPLOYED": "Después pediremos una prueba. Tenga a mano cartas de beneficios de desempleo."
      },
      "employerName": "Nombre del empleador",
      "enterName": "Poner nombre",
      "enterTypeOfWork": "Poner tipo de trabajo",
      "grossMonthlyIncome": "Ingreso mensual bruto (antes de impuestos)",
      "payFrequency": "Frecuencia de pago",
      "selfEmploymentNetMonthlyIncome": "Ingreso mensual NETO estimado tras gastos",
      "title": "Elija tipo de ingreso",
      "typeOfWork": "Tipo de trabajo",
      "unemploymentCompensationStatus": "¿Recibe pagos por desempleo?",
      "workWeekHours": "Horas por semana"
    },
    "monthlyIncome": "{{monthlyIncome}} / mes",
    "title": "Trabajo e ingresos"
  },
  "applicationsListScreen": {
    "applicationDate": "DD/MM/YYYY [a las] h:mm A",
    "inProgress": "En camino",
    "noApplications": "No tienes ninguna solicitud todavía.",
    "submitted": "Enviada",
    "title": "Solicitudes de {{applicationType}}"
  },
  "authScreen": {
    "appleSignInFailed": "No pudimos iniciar sesión con Apple. Por favor, intenta de nuevo o usa otra opción.",
    "checkYourEmail": "Revise su correo",
    "checkYourSpam": "¿No lo recibió? Revise su carpeta de correo no deseado o espere un poco.",
    "continueWithApple": "Continuar con Apple",
    "continueWithGoogle": "Continuar con Google",
    "dataSecured": "Sus datos están seguros. Cumplimos con HIPAA y SOC 2.",
    "emailInput": "Correo electrónico",
    "googleSignInFailed": "No pudimos iniciar sesión con Google. Por favor, intenta de nuevo o usa otra opción.",
    "identifierInput": "Correo electrónico o nombre de usuario",
    "invalidIdentifier": "Ingrese un correo electrónico o nombre de usuario válido.",
    "subtitle": "Ingrese su correo electrónico o nombre de usuario para continuar.",
    "title": "Entrar o crear cuenta",
    "weSentALink": "Enviamos un enlace seguro a <bold>{{email}}</bold>. Ábralo para seguir.",
    "youAgree": "Al seguir, acepta nuestros <underline><colorEmphasis>Términos de servicio</colorEmphasis></underline> y <privacyLink><colorEmphasis>Política de privacidad</colorEmphasis></privacyLink>."
  },
  "brokerConsent": {
    "noButton": "No, gracias",
    "recommendedBadge": "Recomendado",
    "yesButton": "Sí, conéctame"
  },
  "brokerConsentScreen": {
    "continueWithMedicaidOnlyButton": "Continuar solo con Medicaid",
    "continueWithoutAgentButton": "Continuar sin un agente",
    "declineCard": {
      "applyLink": "Solicitar {{program}}",
      "fallbackWithMedicaid": "Aún puedes continuar tu solicitud de Medicaid aquí. Pointcare puede encargarse de tu solicitud de Medicaid sin un agente.",
      "fallbackWithoutMedicaid": "Aún puedes continuar tu solicitud aquí. Terminarla ahora significa que Pointcare podrá apoyarte cuando cambien tus necesidades de cobertura.",
      "selfEnrollmentWarning": "Sin un agente, tendrás que inscribirte en {{programs}} por tu cuenta.",
      "title": "Selecciona “Sí, conéctame” para aprovechar al máximo Pointcare"
    },
    "subtitle": "Te conectaremos cuando sea el momento de inscribirte y solo compartiremos lo necesario para ayudarte.",
    "subtitleWithIndividual": "Te conectaremos cuando sea el momento de inscribirte y solo compartiremos lo necesario para ayudarte. Si estás solicitando Medicare, este agente será {{brokerName}}.",
    "subtitleWithIndividualLicense": "Te conectaremos cuando sea el momento de inscribirte y solo compartiremos lo necesario para ayudarte. Si estás solicitando Medicare, este agente será {{brokerName}} (Licencia n.º: {{licenseNumber}}).",
    "subtitleWithOrganization": "Te conectaremos cuando sea el momento de inscribirte y solo compartiremos lo necesario para ayudarte. Si estás solicitando Medicare, este agente será de {{brokerName}}.",
    "subtitleWithOrganizationLicense": "Te conectaremos cuando sea el momento de inscribirte y solo compartiremos lo necesario para ayudarte. Si estás solicitando Medicare, este agente será de {{brokerName}} (Licencia n.º: {{licenseNumber}}).",
    "title": "Conéctate con un agente de seguros licenciado para explorar opciones de Medicare y/o del Mercado de la ACA y recibir ayuda para completar tu inscripción"
  },
  "camera": {
    "grantPermission": "Dar permiso",
    "permissionDescription": "Para tomar fotos de tus documentos, permite el acceso a la cámara en los ajustes de tu teléfono.",
    "permissionRequired": "Necesitamos acceso a tu cámara.",
    "photoCount": "{{count}} foto(s) tomada(s)",
    "tapToCapture": "Toque el botón para tomar la foto"
  },
  "cesSurvey": {
    "feedbackLabel": "¿Qué fue lo difícil?",
    "feedbackPlaceholder": "Cuéntenos más",
    "optionalLabel": "Opcional",
    "questions": {
      "consentFormSigned": "¿Qué tan fácil fue entender lo que estaba firmando?",
      "householdMemberAdded": "¿Qué tan fácil fue agregar a un miembro del hogar?",
      "incomeAdded": "¿Qué tan fácil fue agregar los ingresos?"
    },
    "scoreEasy": "Fácil",
    "scoreHard": "Difícil",
    "scoreOk": "Regular",
    "scoreVeryEasy": "Muy fácil",
    "scoreVeryHard": "Muy difícil",
    "thanksDescription": "Sus comentarios nos ayudan a mejorar.",
    "thanksTitle": "¡Gracias!"
  },
  "consentDocuments": {
    "addSignature": "Firmar",
    "description": "Firme abajo para que podamos apoyarle.",
    "documentTitle": "Permiso para compartir datos (PDF)",
    "grant1": "Cuidar su cobertura y ver problemas a tiempo",
    "grant2": "Responder a pedidos por usted - sin perder cartas",
    "grant3": "Enviar solicitudes y renovaciones, y dar seguimiento para no perder fechas límite",
    "grant4": "Contactarle con fines de marketing por llamadas telefónicas regulares o automáticas, mensajes de voz y mensajes de texto",
    "grantHealthPlanSelection": "Aplicar su elección de plan de salud y médico (cuando esté disponible) a su cobertura",
    "grantSubtitle": "Esto incluye:",
    "healthPlanAvailabilityError": "No pudimos consultar los planes de salud disponibles. Inténtelo de nuevo antes de firmar.",
    "signatureCountsAsInitials": "Su firma también cuenta como sus iniciales en el formulario cuando corresponda.",
    "title": "Manejo de la cobertura de su familia",
    "viewDocument": "Ver documento"
  },
  "coverage": {
    "code": "Código:",
    "coverageStatus": "Estado de cobertura",
    "inProgress": "En camino",
    "isCovered": "{{name}} tiene cobertura con {{programs}}.",
    "lastCheck": "Última revisión",
    "lastCheckDateFormat": "DD/MM/YYYY",
    "lastCheckWithDate": "Última revisión {{date}}",
    "noMatchingRecord": "No pudimos encontrar tu cobertura. Por favor, revisa tus datos e intenta de nuevo.",
    "planName": "Nombre del plan",
    "primaryCareProvider": "Médico principal",
    "programCoverage": "Cobertura de {{program}}",
    "programListing": {
      "medicaid": "<bold>Medicaid</bold>",
      "medicare": "<bold>Medicare</bold>",
      "medicareAndMedicaid": "<bold>Medicare</bold> y <bold>Medicaid</bold>"
    },
    "serviceTypes": "Servicios incluidos",
    "status": {
      "checking": "Buscando cobertura...",
      "checkingShort": "Buscando...",
      "covered": "Con cobertura",
      "coveredBy": "Cubierto por {{ programs }}",
      "notCovered": "Sin cobertura",
      "unknown": "No se sabe",
      "unknownShort": "Desconocido"
    },
    "updateProfileInformation": "Actualizar perfil"
  },
  "createPasswordScreen": {
    "passwordInputLabel": "Contraseña",
    "passwordInputPlaceholder": "Cree una contraseña",
    "passwordRequirement": "Use al menos 10 letras o números.",
    "subtitle": "Proteja su cuenta con una contraseña segura para seguir.",
    "title": "Crear contraseña"
  },
  "createUsernameAccountScreen": {
    "passwordInputLabel": "Contraseña",
    "passwordInputPlaceholder": "Crea una contraseña",
    "subtitle": "Proteja su cuenta con una contraseña segura para seguir.",
    "title": "Crear contraseña"
  },
  "dateOfBirthInput": {
    "dayPlaceholder": "DD",
    "monthPlaceholder": "MM",
    "yearPlaceholder": "AAAA"
  },
  "eligibilityHouseholdIncomeScreen": {
    "description1": "Use su ingreso BRUTO (antes de impuestos). Si trabaja por su cuenta, use lo que queda después de gastos de negocio.",
    "description2": "Esto incluye el ingreso estimado de todos en la casa:",
    "hideBreakdown": "Ocultar detalle",
    "householdIncomeCalculator": {
      "annualDescription": "Ponga el ingreso anual de cada persona",
      "biWeeklyDescription": "Ponga el ingreso de cada 2 semanas",
      "monthlyDescription": "Ponga el ingreso mensual de cada persona",
      "period": {
        "annual": "año",
        "biWeekly": "2 semanas",
        "monthly": "mes"
      },
      "title": "Calcular ingresos",
      "totalIncomeTitle": "Ingreso total del hogar:",
      "totalIncomeValue": "{{total}} / {{period}}",
      "useRange": "Usar {{label}}"
    },
    "incomePeriod": {
      "annual": "Anual",
      "biWeekly": "Cada 2 semanas",
      "monthly": "Mensual"
    },
    "incomeRange": {
      "0-1800": "$0 - $1,800",
      "0-3700": "$0 - $3,700",
      "0-44400": "$0 - $44,400",
      "1600-2600": "$1,600 - $2,600",
      "2500-3000": "$2,500 - $3,000",
      "3000-3300": "$3,000 - $3,300",
      "3300+": "$3,300 o más",
      "3500-5600": "$3,500 - $5,600",
      "43000-67000": "$43,000 - $67,000",
      "5500-6500": "$5,500 - $6,500",
      "6500-7000": "$6,500 - $7,000",
      "66000-78000": "$66,000 - $78,000",
      "7000+": "$7,000 o más",
      "78000-83000": "$78,000 - $83,000",
      "83000+": "$83,000 o más"
    },
    "showBreakdown": "¿Necesita ayuda? Ver detalle",
    "title": "¿Cuál es el ingreso aproximado de su hogar?",
    "updateError": "No pudimos guardar tus ingresos. Por favor, intenta de nuevo."
  },
  "eligibilityHouseholdMembers": {
    "title": "Tu hogar",
    "you": "Tú"
  },
  "eligibilityLiveAndCareScreen": {
    "description": "Deben <bold>vivir con usted</bold> por <bold>más de medio año</bold> y usted debe <bold>pagar más de la mitad</bold> de sus <bold>gastos anuales</bold> (comida, casa, escuela y médicos). Esto incluye parientes no consanguíneos.",
    "formDescription": "Agregue a hijos, hijastros, nietos o hijos de crianza menores de 19 años que vivan con usted y que usted apoye.",
    "formTitle": "Cuéntenos sobre los niños que apoya",
    "supporterDescription": "Deben <bold>vivir con {{supporterFirstName}}</bold> por <bold>más de medio año</bold> y {{supporterFirstName}} debe <bold>pagar más de la mitad</bold> de sus <bold>gastos anuales</bold>.",
    "supporterFormDescription": "Agregue a cualquier niño menor de 19 años que viva con {{supporterFirstName}}.",
    "supporterFormTitle": "Cuéntenos sobre los niños de {{supporterFirstName}}",
    "supporterTitle": "¿Vive {{supporterFirstName}} con algún niño menor de 19 años y lo cuida?",
    "title": "¿Vive usted con algún niño menor de 19 años y lo cuida?"
  },
  "eligibilityMaritalStatusScreen": {
    "description": "Esto nos ayuda a saber para qué programas podría calificar su familia.",
    "formDescription": "Necesitamos datos básicos de su pareja para ver si califica.",
    "formTitle": "Cuéntenos sobre su pareja",
    "supporterFormDescription": "Necesitamos datos básicos de la pareja de {{supporterFirstName}}.",
    "supporterFormTitle": "Cuéntenos sobre la pareja de {{supporterFirstName}}",
    "supporterTitle": "¿Cuál es el estado civil de {{supporterFirstName}}?",
    "title": "¿Cuál es su estado civil?"
  },
  "eligibilityParentGuardianStudentScreen": {
    "description": "Usted debe <bold>pagar más de la mitad</bold> de sus <bold>gastos anuales</bold> (comida, casa, escuela y médicos).",
    "formDescription": "Agregue estudiantes de tiempo completo de 18 a 21 años de los que usted sea padre o tutor.",
    "formTitle": "Cuéntenos sobre el estudiante que apoya",
    "supporterDescription": "{{supporterFirstName}} debe <bold>pagar más de la mitad</bold> de sus <bold>gastos anuales</bold>.",
    "supporterFormDescription": "Agregue estudiantes de 18 a 21 años que {{supporterFirstName}} apoye.",
    "supporterFormTitle": "Cuéntenos sobre el estudiante que {{supporterFirstName}} apoya",
    "supporterTitle": "¿Es {{supporterFirstName}} padre o tutor de un estudiante de 18 a 21 años?",
    "title": "¿Es usted padre o tutor de un estudiante de 18 a 21 años al que apoya económicamente?"
  },
  "eligibilitySomeoneSupportsYou": {
    "description": "Esto incluye comida, casa, escuela y médicos.",
    "errors": {
      "updateFailed": "No pudimos guardar esos cambios. Por favor, intenta de nuevo."
    },
    "formDescription": "Agregue a la persona que paga más de la mitad de sus gastos, como un padre o tutor.",
    "formTitle": "Cuéntenos sobre la persona que le apoya",
    "options": {
      "disabled": "Sí, tengo una discapacidad y vivo todo el año con quien me apoya.",
      "fullTimeStudent": "Sí, soy estudiante de tiempo completo y mis padres me apoyan.",
      "personSupportsMe": "Sí, vivo más de medio año con quien me apoya.",
      "relativeSupportsMe": "Sí, vivo más de medio año con un familiar que me apoya."
    },
    "title": "¿Alguien paga más de la mitad de sus gastos anuales?"
  },
  "eligibilitySpecialConditionsScreen": {
    "addDetails": "Agregar detalles",
    "conditions": {
      "blind": "Alguien es ciego",
      "breastCancer": "Alguien tiene cáncer de mama",
      "cervicalCancer": "Alguien tiene cáncer de cuello uterino",
      "disabled": "Alguien tiene discapacidad (SSDI)",
      "fosterCare": "Alguien estuvo en hogares de crianza al cumplir 18",
      "pregnant": "Alguien está embarazada"
    },
    "description": "Marque cualquier situación que aplique a su hogar.",
    "errors": {
      "allUpdatesFailed": "No pudimos guardar esos cambios. Por favor, intenta de nuevo."
    },
    "pregnancyDetails": {
      "estimatedDueDate": "Fecha estimada del parto",
      "numberOfBabies": "Cuántos bebés espera",
      "title": "Detalles del embarazo"
    },
    "pregnancyInfo": {
      "babiesWithCount_one": "{{count}} bebé • Fecha: {{date}}",
      "babiesWithCount_other": "{{count}} bebés • Fecha: {{date}}"
    },
    "title": "Casos especiales en su hogar"
  },
  "eligibilitySupportDisabledIndividualScreen": {
    "description": "Puede ser cualquier persona (hijo, abuelo, etc.). Usted debe <bold>pagar más de la mitad</bold> de sus <bold>gastos anuales</bold>.",
    "formDescription": "Agregue personas con discapacidad que vivan con usted todo el año y a las que apoye.",
    "formTitle": "Cuéntenos sobre la persona con discapacidad",
    "supporterDescription": "Puede ser cualquiera. {{supporterFirstName}} debe <bold>pagar más de la mitad</bold> de sus <bold>gastos anuales</bold>.",
    "supporterFormDescription": "Agregue personas que vivan con {{supporterFirstName}} y que él/ella apoye.",
    "supporterFormTitle": "Cuéntenos sobre la persona que {{supporterFirstName}} apoya",
    "supporterTitle": "¿Apoya {{supporterFirstName}} a alguien con discapacidad que viva con él/ella?",
    "title": "¿Apoya usted a alguna persona con discapacidad que viva con usted todo el año?"
  },
  "eligibilitySupportOtherRelativesScreen": {
    "description": "Deben <bold>vivir con usted</bold> más de medio año y usted debe <bold>pagar más de la mitad</bold> de sus gastos.",
    "formDescription": "Agregue familiares directos o extendidos que vivan con usted y que usted apoye.",
    "formTitle": "Cuéntenos sobre los familiares que apoya",
    "supporterDescription": "Deben <bold>vivir con {{supporterFirstName}}</bold> más de medio año.",
    "supporterFormDescription": "Agregue familiares que vivan con {{supporterFirstName}} y reciban su apoyo.",
    "supporterFormTitle": "Familiares que {{supporterFirstName}} apoya",
    "supporterTitle": "¿Apoya {{supporterFirstName}} a otros familiares que viven con él/ella?",
    "title": "¿Apoya usted a otros familiares que vivan con usted?"
  },
  "homeScreen": {
    "addMember": "Agregar miembro",
    "applicationSubmittedCard_multiple": "Envió solicitudes de <programs /> para {{memberNames}}. Las revisaremos y nos comunicaremos con usted si necesitamos algo.",
    "applicationSubmittedCard_single": "Envió una solicitud de <programs /> para {{memberNames}}. La revisaremos y nos comunicaremos con usted si necesitamos algo.",
    "applicationSubmittedCard_singleMarketplace": "Envió una solicitud de <programs /> para {{memberNames}}. La revisaremos y nos comunicaremos con usted si necesitamos algo.",
    "checkEligibility": "Ver si califica",
    "checkEligibilityCompact": "Ver si califica",
    "devScenarioActive": "Escenario simulado activo — el panel muestra datos de prueba.",
    "devScenarioReset": "Restablecer",
    "eligibilityCardCompactNotStarted": "Vea a qué programas podría calificar",
    "eligibilityCardCompactStarted": "Continúe para ver a qué programas podría calificar",
    "eligibilityCardNotStarted": "Inicie una revisión rápida para ver a qué programas podría calificar su hogar",
    "eligibilityCardStarted": "Siga con su revisión para ver a qué programas podría calificar su hogar",
    "household": "Hogar",
    "logout": "Salir",
    "nextSteps": "Próximos pasos",
    "recheckEligibility": "Revisar de nuevo"
  },
  "householdMemberScreen": {
    "applicantDocuments": "Documentos del solicitante",
    "checkCoverage": "Ver cobertura",
    "deleteButton": "Quitar a {{memberFullName}} del hogar",
    "deleteDialog": {
      "description": "Esto borrará a {{memberFullName}} de su hogar para siempre. Sus datos y documentos se perderán y no se pueden recuperar.",
      "title": "Quitar miembro del hogar"
    },
    "deleteToast": {
      "error": "No pudimos eliminar a ese miembro de la familia. Por favor, intenta de nuevo.",
      "success": "Miembro del hogar quitado correctamente"
    },
    "profileInformation": "Datos del perfil"
  },
  "landingScreen": {
    "goToAuth": "Ir a entrar"
  },
  "languageSelectorModal": {
    "title": "Elegir idioma"
  },
  "languages": {
    "arabicDescription": "Árabe",
    "chineseSimplifiedDescription": "Chino simplificado",
    "englishDescription": "Inglés",
    "haitianCreoleDescription": "Criollo haitiano",
    "russianDescription": "Ruso",
    "spanishDescription": "Español",
    "tagalogDescription": "Tagalo",
    "vietnameseDescription": "Vietnamita"
  },
  "memberFormSubmission": {
    "error": "No pudimos guardar esos cambios. Por favor, intenta de nuevo.",
    "success": "Miembro del hogar actualizado correctamente"
  },
  "mfaPhoneScreen": {
    "phoneNumberLabel": "Número de teléfono",
    "phoneNumberPlaceholder": "(555) 000-0000",
    "sendVerificationCodeText": "Le enviaremos un código de revisión.",
    "subtitle": "Usaremos esto para proteger su cuenta.",
    "title": "¿Cuál es su teléfono?"
  },
  "mfaVerifyScreen": {
    "getNewCode": "Pedir código nuevo",
    "subtitle": "Ponga el código de 6 números que enviamos a\n<bold>{{phoneNumber}}</bold>",
    "title": "Le enviamos un código",
    "verificationCodeLabel": "Código de revisión"
  },
  "notFound": {
    "cta": "Ir al inicio",
    "description": "La página que buscas ya no existe.",
    "title": "No se encontró la página."
  },
  "npsSurveyScreen": {
    "highFeedbackLabel": "¿Qué fue lo que más le gustó de Pointcare? (opcional)",
    "highFeedbackPlaceholder": "Cuéntenos qué destacó",
    "lowFeedbackLabel": "¿Qué podríamos mejorar? (opcional)",
    "lowFeedbackPlaceholder": "Cuéntenos qué salió mal...",
    "mediumFeedbackLabel": "¿Qué habría hecho que esto fuera un 10 para usted? (opcional)",
    "mediumFeedbackPlaceholder": "¿Qué lo habría hecho mejor...",
    "scaleHighLabel": "→ Muy probable",
    "scaleLowLabel": "→ Nada probable",
    "submitButton": "Enviar comentarios",
    "subtitle": "Sus respuestas nunca se comparten con los programas a los que solicitó ingreso.",
    "success": "Comentarios enviados correctamente.",
    "testimonialLabel": "¿Podemos compartir sus comentarios en nuestro sitio web para ayudar a más personas a encontrar cobertura? Solo usaremos su nombre.",
    "title": "¿Qué tan probable es que recomiende Pointcare a un amigo o familiar?"
  },
  "onboarding": {
    "benefits": {
      "description": "Pointcare ayuda a más de 1.8 millones de pacientes en EE. UU. a buscar y mantener su seguro.",
      "firstItem": "Vea quién califica en 5 min",
      "firstItem_AGING_INTO_MEDICARE": "Busque el Medicare correcto",
      "firstItem_AGING_INTO_MEDICARE_awareness": "Siga las fechas importantes",
      "firstItem_LAPSE": "Vea quién califica en 5 min",
      "firstItem_QR_CODE": "Vea quién califica en 5 min",
      "firstItem_RECURRING_WORK_REQUIREMENT": "No pierda fechas límite",
      "firstItem_REDETERMINATION": "No pierda fechas límite",
      "firstItem_SELF_PAY_CONVERSION": "Vea quién califica en 5 min",
      "firstItem_SERVICE_INTRODUCTION_medicaid": "No pierda fechas límite",
      "firstItem_SERVICE_INTRODUCTION_medicare": "Revise sus beneficios en 5 min",
      "freeToUse": "Ayuda gratuita, sin cobros ocultos",
      "infoIsPrivate": "Su información es privada",
      "title": "{{clinicName}} se unió a Pointcare para apoyar a su familia",
      "titleNoClinic": "Pointcare está aquí para apoyar a su familia"
    },
    "buttons": {
      "createMyProfile": "Crear mi perfil",
      "getStarted": "Empezar"
    },
    "concerns": {
      "description": "Elija la opción que más le importa. Le enseñaremos cómo ayudar.",
      "description_SERVICE_INTRODUCTION_medicare": "Elija la opción que mejor describa esta cobertura.",
      "title": "¿Qué es lo que más le preocupa de la cobertura de su familia?",
      "title_SERVICE_INTRODUCTION_medicare": "¿Qué cobertura de Medicare tiene su familia?"
    },
    "figuringOutWhenToRenew": {
      "option": "Saber cuándo renovar",
      "subtext": "Cuidaremos las fechas de todos y le avisaremos antes de que sea tarde."
    },
    "figuringOutWhenToSubmitRequirements": {
      "option": "Saber cuándo enviar requisitos",
      "subtext": "Cuidaremos las fechas de trabajo de todos y le avisaremos a tiempo."
    },
    "imNotSure": {
      "option": "No estoy seguro",
      "subtext": "Nos aseguraremos de que el plan de cada uno siga funcionando bien."
    },
    "intro": {
      "description": "Mucha gente no paga nada. Otros pagan solo $20–30 al mes. Haremos unas preguntas para buscar la mejor opción.",
      "description_AGING_INTO_MEDICARE": "Seguro recibe muchas ofertas. Como su médico, le ayudaremos a buscar el plan correcto.",
      "description_AGING_INTO_MEDICARE_awareness": "Seguro recibe muchas ofertas. Como su médico, le ayudaremos a buscar el plan correcto.",
      "description_LAPSE": "7 de cada 10 personas pueden volver a calificar para ayuda. Sea volver a Medicaid o buscar otra opción, le ayudaremos.",
      "description_QR_CODE": "Mucha gente no paga nada. Otros pagan muy poco. Haremos unas preguntas para buscar la mejor opción.",
      "description_RECURRING_WORK_REQUIREMENT": "Una ley pide prueba de ingresos. Veremos si alguien está exento o al día y le apoyaremos.",
      "description_REDETERMINATION": "Debe confirmar o cambiar los datos de su hogar para seguir cubiertos. Le ayudaremos en todo.",
      "description_SELF_PAY_CONVERSION": "Mucha gente no paga nada. Otros pagan poco. Haremos unas preguntas para buscar la mejor opción.",
      "description_SERVICE_INTRODUCTION_medicaid": "Cuidaremos su cobertura, ayudaremos con renovaciones y dudas, todo gratis.",
      "description_SERVICE_INTRODUCTION_medicare": "Le ayudaremos a entender su cobertura, buscar beneficios extras y no perder nada.",
      "title": "Tener seguro de salud no tiene que ser difícil. Su familia podría calificar para <colorEmphasis>planes gratis o de bajo costo</colorEmphasis>.",
      "title_AGING_INTO_MEDICARE": "Parece que alguien califica para Medicare hace <colorEmphasis>{{count}} meses</colorEmphasis>. Estamos aquí para ayudar.",
      "title_AGING_INTO_MEDICARE_awareness_one": "Parece que alguien califica para Medicare <colorEmphasis>en {{monthsToTurning65}} mes</colorEmphasis>. Estamos aquí para ayudar.",
      "title_AGING_INTO_MEDICARE_awareness_other": "Parece que alguien califica para Medicare <colorEmphasis>en {{monthsToTurning65}} meses</colorEmphasis>. Estamos aquí para ayudar.",
      "title_AGING_INTO_MEDICARE_one": "Parece que alguien califica para Medicare hace <colorEmphasis>{{count}} mes</colorEmphasis>. Estamos aquí para ayudar.",
      "title_AGING_INTO_MEDICARE_other": "Parece que alguien califica para Medicare hace <colorEmphasis>{{count}} meses</colorEmphasis>. Estamos aquí para ayudar.",
      "title_AGING_INTO_MEDICARE_zero": "Parece que alguien califica para Medicare <colorEmphasis>a partir de este mes</colorEmphasis>. Estamos aquí para ayudar.",
      "title_LAPSE": "Parece que alguien perdió su cobertura de {{payerName}} el <colorEmphasis>{{lapseDate}}</colorEmphasis>. Ayudaremos a recuperarla.",
      "title_QR_CODE": "Su familia podría tener <colorEmphasis>salud gratis o de bajo costo</colorEmphasis>. Vamos a ver.",
      "title_RECURRING_WORK_REQUIREMENT_one": "Parece que alguien debe entregar requisitos de trabajo de {{payerName}} <colorEmphasis>en {{count}} mes</colorEmphasis>. Sigamos cubiertos.",
      "title_RECURRING_WORK_REQUIREMENT_other": "Parece que alguien tiene requisitos de {{payerName}} <colorEmphasis>en {{count}} meses</colorEmphasis>. Sigamos cubiertos.",
      "title_RECURRING_WORK_REQUIREMENT_zero": "Parece que alguien tiene requisitos de {{payerName}} <colorEmphasis>este mes</colorEmphasis>. Sigamos cubiertos.",
      "title_REDETERMINATION_one": "Parece que alguien tiene una renovación de {{payerName}} <colorEmphasis>en {{count}} mes</colorEmphasis>. Sigamos cubiertos.",
      "title_REDETERMINATION_other": "Parece que alguien tiene una renovación de {{payerName}} <colorEmphasis>en {{count}} meses</colorEmphasis>. Sigamos cubiertos.",
      "title_REDETERMINATION_zero": "Parece que alguien tiene una renovación de {{payerName}} <colorEmphasis>este mes</colorEmphasis>. Sigamos cubiertos.",
      "title_SERVICE_INTRODUCTION_medicaid": "Estamos aquí para que su familia <colorEmphasis>siga con {{payerName}}.</colorEmphasis>",
      "title_SERVICE_INTRODUCTION_medicare": "¿Está su familia <colorEmphasis>sacando el máximo de {{payerName}}?</colorEmphasis> Le ayudamos."
    },
    "keepingMyCurrentDoctors": {
      "option": "Seguir con mis médicos",
      "subtext": "Ayudaremos a buscar un plan que incluya a los médicos que ya ven."
    },
    "meetingRequirements": {
      "option": "Cumplir con los requisitos",
      "subtext": "Apoyaremos a todos para cumplir y enviar sus papeles de trabajo."
    },
    "missingEnrolmentDeadline": {
      "option": "Perder las fechas de inscripción",
      "subtext": "Le avisaremos cuándo inscribirse para evitar multas."
    },
    "nextSteps": {
      "step1Description": "Cuéntenos sobre usted",
      "step1Duration": "2 min",
      "step1Title": "Crear perfil",
      "step2Description": "Cobertura para la que califican",
      "step2Description_AGING_INTO_MEDICARE": "Revisar estado actual",
      "step2Description_AGING_INTO_MEDICARE_awareness": "Revisar estado actual",
      "step2Description_LAPSE": "Cobertura para la que califican",
      "step2Description_QR_CODE": "Cobertura para la que califican",
      "step2Description_RECURRING_WORK_REQUIREMENT": "Veremos si están exentos o al día",
      "step2Description_RECURRING_WORK_REQUIREMENT_awareness": "Veremos si están exentos o al día",
      "step2Description_REDETERMINATION": "Nuestro equipo le llamará",
      "step2Description_REDETERMINATION_awareness": "Incluye datos de contacto básicos",
      "step2Description_SELF_PAY_CONVERSION": "Cobertura para la que califican",
      "step2Description_SERVICE_INTRODUCTION_medicaid": "Revisar estado actual",
      "step2Description_SERVICE_INTRODUCTION_medicare": "Revisar estado actual",
      "step2Description_SERVICE_INTRODUCTION_medicare_partABorD": "Revisar estado actual",
      "step2Duration": "5 min",
      "step2Duration_AGING_INTO_MEDICARE": "2 min",
      "step2Duration_AGING_INTO_MEDICARE_awareness": "2 min",
      "step2Duration_LAPSE": "5 min",
      "step2Duration_QR_CODE": "5 min",
      "step2Duration_RECURRING_WORK_REQUIREMENT": "5 min",
      "step2Duration_RECURRING_WORK_REQUIREMENT_awareness": "5 min",
      "step2Duration_REDETERMINATION": "2 min",
      "step2Duration_SELF_PAY_CONVERSION": "5 min",
      "step2Duration_SERVICE_INTRODUCTION_medicaid": "2 min",
      "step2Duration_SERVICE_INTRODUCTION_medicare": "2 min",
      "step2Duration_SERVICE_INTRODUCTION_medicare_partABorD": "2 min",
      "step2Title": "Ver sus opciones",
      "step2Title_AGING_INTO_MEDICARE": "Ver cobertura",
      "step2Title_AGING_INTO_MEDICARE_awareness": "Ver cobertura",
      "step2Title_LAPSE": "Ver sus opciones",
      "step2Title_QR_CODE": "Ver sus opciones",
      "step2Title_RECURRING_WORK_REQUIREMENT": "Ver requisitos",
      "step2Title_RECURRING_WORK_REQUIREMENT_awareness": "Ver requisitos",
      "step2Title_REDETERMINATION": "Pedir apoyo para renovar",
      "step2Title_REDETERMINATION_awareness": "Datos del hogar",
      "step2Title_SELF_PAY_CONVERSION": "Ver sus opciones",
      "step2Title_SERVICE_INTRODUCTION_medicaid": "Ver cobertura",
      "step2Title_SERVICE_INTRODUCTION_medicare": "Ver cobertura",
      "step2Title_SERVICE_INTRODUCTION_medicare_partABorD": "Ver cobertura",
      "step3Description": "¡Nosotros haremos el resto!",
      "step3Description_AGING_INTO_MEDICARE": "¡Nosotros haremos el resto!",
      "step3Description_AGING_INTO_MEDICARE_awareness": "Le mantendremos informado",
      "step3Description_LAPSE": "¡Nosotros haremos el resto!",
      "step3Description_QR_CODE": "¡Nosotros haremos el resto!",
      "step3Description_RECURRING_WORK_REQUIREMENT": "Le guiaremos en esto",
      "step3Description_RECURRING_WORK_REQUIREMENT_awareness": "Le ayudaremos a cumplir los requisitos",
      "step3Description_REDETERMINATION": "Le guiaremos en esto",
      "step3Description_REDETERMINATION_awareness": "Le mantendremos listo",
      "step3Description_SELF_PAY_CONVERSION": "¡Nosotros haremos el resto!",
      "step3Description_SERVICE_INTRODUCTION_medicaid": "Le avisaremos con tiempo",
      "step3Description_SERVICE_INTRODUCTION_medicare": "Vea lo que incluye el plan",
      "step3Description_SERVICE_INTRODUCTION_medicare_partABorD": "Mejorar beneficios",
      "step3Duration": "15 min",
      "step3Duration_SERVICE_INTRODUCTION_medicare": "1 min",
      "step3Title": "Enviar solicitud",
      "step3Title_AGING_INTO_MEDICARE": "Enviar a Medicare",
      "step3Title_AGING_INTO_MEDICARE_awareness": "Listo para Medicare",
      "step3Title_LAPSE": "Enviar solicitud",
      "step3Title_QR_CODE": "Enviar solicitud",
      "step3Title_RECURRING_WORK_REQUIREMENT": "Enviar requisitos",
      "step3Title_RECURRING_WORK_REQUIREMENT_awareness": "Adelántese a los requisitos",
      "step3Title_REDETERMINATION": "Enviar renovación",
      "step3Title_REDETERMINATION_awareness": "Cerca de su renovación",
      "step3Title_SELF_PAY_CONVERSION": "Enviar solicitud",
      "step3Title_SERVICE_INTRODUCTION_medicaid": "No pierda una fecha",
      "step3Title_SERVICE_INTRODUCTION_medicare": "Revise sus beneficios",
      "step3Title_SERVICE_INTRODUCTION_medicare_partABorD": "Ver opciones Medicare",
      "title": "¿Listo para dar cobertura a su familia?",
      "title_RECURRING_WORK_REQUIREMENT": "Mantengamos a su familia cubierta",
      "title_RECURRING_WORK_REQUIREMENT_awareness": "Mantengamos a su familia cubierta",
      "title_REDETERMINATION": "Mantengamos a su familia cubierta",
      "title_REDETERMINATION_awareness": "Mantengamos a su familia cubierta",
      "title_SERVICE_INTRODUCTION_medicaid": "Mantengamos a su familia cubierta",
      "title_SERVICE_INTRODUCTION_medicare": "Mantengamos a su familia cubierta",
      "title_SERVICE_INTRODUCTION_medicare_partABorD": "Mantengamos a su familia cubierta"
    },
    "notKnowingHowToGetCovered": {
      "option": "No saber cómo obtener cobertura",
      "subtext": "Le guiaremos paso a paso para que todos tengan cobertura."
    },
    "notKnowingImCovered": {
      "option": "No saber quién tiene cobertura",
      "subtext": "Podemos ver si todos tienen cobertura y ayudarles a conseguirla.",
      "subtext_RECURRING_WORK_REQUIREMENT": "Veremos la cobertura de todos y ayudaremos a conseguirla.",
      "subtext_RECURRING_WORK_REQUIREMENT_awareness": "Veremos la cobertura de todos y ayudaremos a conseguirla.",
      "subtext_REDETERMINATION": "Veremos la cobertura de todos y ayudaremos a conseguirla.",
      "subtext_REDETERMINATION_awareness": "Veremos la cobertura de todos y ayudaremos a conseguirla.",
      "subtext_SERVICE_INTRODUCTION_medicaid": "Veremos la cobertura de todos y ayudaremos a conseguirla."
    },
    "paperwork": {
      "option": "Mucho papeleo o muy confuso",
      "subtext": "Nosotros haremos todo el papeleo, desde la cobertura hasta las renovaciones.",
      "subtext_SERVICE_INTRODUCTION": "Trabajamos con su médico para buscar la mejor opción para su salud."
    },
    "partAB": {
      "option": "Parte A y B (Medicare)",
      "subtext": "Buscaremos la mejor opción, sea su plan actual o Medicare Advantage."
    },
    "partABD": {
      "option": "Parte A, B y D (Medicare + Medicinas)",
      "subtext": "Buscaremos la mejor opción para cada uno."
    },
    "partC": {
      "option": "Parte C (Medicare Advantage)",
      "subtext": "Nos aseguraremos de que el plan siga funcionando para todos."
    },
    "payingForDoctor": {
      "option": "Pagar médico y medicinas",
      "subtext": "Ayudaremos a buscar cobertura que baje los costos de salud."
    },
    "somethingElse": {
      "option": "Algo más",
      "subtext": "Ayudaremos a todos a tener cobertura y mantenerla.",
      "subtext_AGING_INTO_MEDICARE": "Le guiaremos para obtener Medicare paso a paso.",
      "subtext_AGING_INTO_MEDICARE_awareness": "Le guiaremos para obtener Medicare paso a paso.",
      "subtext_RECURRING_WORK_REQUIREMENT": "Ayudaremos a que todos mantengan su cobertura sin sorpresas.",
      "subtext_RECURRING_WORK_REQUIREMENT_awareness": "Ayudaremos a que todos mantengan su cobertura sin sorpresas.",
      "subtext_REDETERMINATION": "Olvide el papeleo confuso. Ayudaremos a que todos sigan cubiertos.",
      "subtext_REDETERMINATION_awareness": "Olvide el papeleo confuso. Ayudaremos a que todos sigan cubiertos.",
      "subtext_SERVICE_INTRODUCTION_medicaid": "Olvide el papeleo confuso. Ayudaremos a que todos sigan cubiertos.",
      "subtext_SERVICE_INTRODUCTION_medicare": "Nos aseguraremos de que el plan siga funcionando bien."
    },
    "submittingRenewals": {
      "option": "Enviar renovaciones",
      "subtext": "Nosotros haremos las renovaciones. Solo responda unas preguntas."
    },
    "tooManyMedicareAdsAndCalls": {
      "option": "Muchos anuncios y llamadas de Medicare",
      "subtext": "Le ayudaremos a ignorar el ruido y buscar el plan ideal."
    },
    "variants": {
      "improvedVerbiage": {
        "benefits": {
          "description": "Pointcare ayuda a más de 1.8 millones de pacientes a buscar y mantener su seguro.",
          "firstItem_LAPSE": "Vea quién califica en 5 min",
          "infoIsPrivate": "Su información está segura con nosotros",
          "title": "{{clinicName}} trabaja con Pointcare para ayudar a su familia"
        },
        "concerns": {
          "description_LAPSE": "Elija lo que más le importa y le mostraremos cómo podemos ayudar.",
          "title_LAPSE": "¿Qué es lo más difícil de conseguir cobertura para su familia?"
        },
        "intro": {
          "description_LAPSE": "La mayoría de las personas vuelven a calificar para cobertura gratis o de bajo costo. Le ayudaremos en cada paso.",
          "title_LAPSE": "Alguien de su familia perdió su cobertura de {{payerName}} el <colorEmphasis>{{lapseDate}}</colorEmphasis>. Estamos aquí para ayudar a recuperarla."
        },
        "nextSteps": {
          "step2Description_LAPSE": "Vea para qué califica su familia"
        },
        "paperwork": {
          "option": "Papeleo confuso"
        }
      }
    }
  },
  "passwordScreen": {
    "forgotPassword": "¿Olvidó su contraseña?",
    "passwordInputLabel": "Contraseña",
    "passwordInputPlaceholder": "Ponga su contraseña",
    "resetPasswordInstructions": "Enviamos un enlace para restablecer la contraseña a <bold>{{email}}</bold>. Ábralo para crear una nueva contraseña.",
    "subtitle": "Ponga su contraseña para seguir.",
    "title": "Ponga su contraseña",
    "usernameResetUnavailable": "Las cuentas con nombre de usuario no pueden restablecer la contraseña por correo. Llámenos y le ayudamos."
  },
  "profileInformationScreen": {
    "addressComplement": "Apto, Unidad, Edificio (opcional)",
    "checkCoverage": "Prueba de cobertura",
    "coverageStatus": "Estado: {{status}}",
    "dateOfBirth": "Fecha de nacimiento",
    "email": "Correo",
    "firstName": "Nombre",
    "homeAddress": "Dirección de casa",
    "lastName": "Apellido",
    "mailingAddress": "Dirección de correo",
    "mailingAddressComplement": "Apt, unidad, edificio, apartado postal (opcional)",
    "medicaidCaseNumber": "Número de caso de Medicaid (opcional)",
    "medicaidSubscriberId": "ID de Medicaid (opcional)",
    "noHomeAddress": "Sin dirección fija",
    "noMailingAddress": "Sin dirección de correo",
    "phoneNumber": "Teléfono",
    "socialSecurityNumber": "Número de Seguro Social",
    "useDifferentMailingAddress": "Usar otra dirección de correo"
  },
  "recheckEligibilityScreen": {
    "button": "Revisar de nuevo",
    "title": "Antes de revisar, asegúrese de que los datos de su hogar estén al día."
  },
  "redeterminationScreen": {
    "addressInformation": "Actualizar datos de dirección",
    "alreadyMailedForm": "Ya envié el papel o lo haré pronto",
    "caseNumberDescription": "¡Usaremos su número de caso para enviar su renovación más rápido!\n\nBúsquelo en su formulario de renovación u otro correo de su agencia estatal sobre su cobertura.",
    "caseNumberDescription_PENDING_FORM": "¡Usaremos su número de caso para enviar su renovación más rápido!\n\nBúsquelo en el correo de su agencia estatal sobre su cobertura.",
    "caseNumberLabel": "Número de caso",
    "caseNumberPlaceholder": "Ingrese el número de caso",
    "caseNumberTitle": "Agreguemos su número de caso (opcional)",
    "description": "Elija la mejor opción",
    "haventReceivedForm": "Aún no recibo el papel",
    "receivedForm": "Recibí el papel y necesito ayuda para llenarlo",
    "returnToDashboard": "Volver al inicio",
    "reviewAddress": "Revise y confirme las direcciones de domicilio y de correo de todos los miembros del hogar. Esto garantiza que el formulario de renovación llegue a la dirección correcta.",
    "successDescription": "Su renovación está resuelta. Nos comunicaremos con usted si algo cambia.",
    "successDescription_CALL_BACK": "Nuestro equipo se comunicará con usted en 1 o 2 días hábiles para completar su renovación.",
    "successDescription_PENDING_FORM": "El formulario de renovación debería llegar a la dirección registrada. Esté atento al correo postal, el correo electrónico y los mensajes de texto. Nos aseguraremos de dar seguimiento antes de la fecha límite.",
    "successTitle": "¡Ya está todo listo!",
    "successTitle_CALL_BACK": "Le llamaremos pronto.",
    "successTitle_PENDING_FORM": "¡Ya está todo listo!",
    "title": "La renovación de alguien de su hogar vence el {{date}}."
  },
  "redeterminations": {
    "cardAggregated_CALL_BACK": "{{total}} renovaciones de Medicaid están en espera de una llamada — con fecha límite {{dates}}. Esté atento a su teléfono.",
    "cardAggregated_NOT_STARTED": "{{total}} renovaciones de Medicaid por iniciar.",
    "cardAggregated_PENDING_FORM": "{{total}} formularios de renovación de Medicaid llegarán pronto. Esté atento al correo postal, correo electrónico y mensajes de texto.",
    "cardCompact_PENDING_FORM": "Formulario de renovación en camino — fecha límite {{date}}",
    "card_CALL_BACK": "Alguien en su hogar tiene una renovación de Medicaid en espera de una llamada — con fecha límite {{date}}. Esté atento a su teléfono.",
    "card_NOT_STARTED": "Alguien en su hogar tiene una renovación de Medicaid con fecha límite {{date}}.",
    "card_PENDING_FORM": "Alguien en su hogar recibirá pronto un formulario de renovación de Medicaid — con fecha límite {{date}}. Esté atento al correo postal, correo electrónico y mensajes de texto.",
    "due": "Fecha límite {{date}}",
    "medicaidRenewals": "Renovaciones de Medicaid",
    "noRenewals": "Aún no hay renovaciones.",
    "startRenewal": "Iniciar renovación",
    "status": "Devolver llamada",
    "status_CALL_BACK": "Llamada solicitada",
    "status_COMPLETED": "Listo",
    "status_NOT_STARTED": "No iniciado",
    "status_PENDING_FORM": "Esperando formulario",
    "title": "Renovaciones",
    "updateStatus": "Actualizar estado"
  },
  "registrationCoverageScreen": {
    "description": "Pointcare puede buscar su cobertura de Medicaid con los datos que ponga abajo.",
    "title": "Vamos a ver su cobertura"
  },
  "registrationProfileScreen": {
    "description": "Ponga sus datos para usarlos en las solicitudes."
  },
  "resetPasswordScreen": {
    "confirmPasswordInputLabel": "Confirme la nueva contraseña",
    "confirmPasswordInputPlaceholder": "Vuelva a ingresar la nueva contraseña",
    "invalidResetLink": "Este enlace para restablecer la contraseña no es válido o ha caducado. Solicite uno nuevo.",
    "passwordInputLabel": "Nueva contraseña",
    "passwordInputPlaceholder": "Ingrese la nueva contraseña",
    "subtitle": "Elija una contraseña segura que no haya usado antes.",
    "title": "Cree una nueva contraseña",
    "updatePasswordButton": "Actualizar contraseña"
  },
  "sessionTimedOut": {
    "description": "Por tu seguridad, cerramos tu sesión por inactividad. Inicia sesión de nuevo para continuar.",
    "loginAgain": "Entrar de nuevo",
    "title": "Tu sesión ha terminado"
  },
  "sessionTimeout": {
    "countdown": "Quedan {{time}}",
    "description": "Tu sesión está por terminar por inactividad. ¿Quieres seguir conectado?",
    "logOutNow": "Salir ahora",
    "secureSession": "Sesión segura",
    "stayLoggedIn": "Seguir en el sistema",
    "title": "¿Todavía estás ahí?"
  },
  "signatureField": {
    "signaturePrompt": "Firme aquí"
  },
  "someHouseholdMembersNotUpdated": "No pudimos guardar los cambios de todos. Por favor, revisa a cada miembro de la familia.",
  "support": {
    "callUs": "Llámenos",
    "callUsAt": "Llámenos al <underline>{{phoneNumber}}</underline>"
  },
  "workRequirements": {
    "cardActionCompact_START": "Iniciar",
    "cardActionCompact_UPLOAD_DOCUMENTS": "Subir",
    "cardAction_CONTINUE": "Continuar requisitos de trabajo",
    "cardAction_START": "Iniciar requisitos de trabajo",
    "cardAction_UPLOAD_DOCUMENTS": "Subir documentos",
    "cardCompact": "Requisitos de trabajo de Medicaid con fecha límite {{date}}",
    "card_CONTINUE": "Alguien en su hogar tiene requisitos de trabajo de Medicaid con fecha límite {{date}}. Termine de revisar quién está al día o exento.",
    "card_START": "Alguien en su hogar tiene requisitos de trabajo de Medicaid con fecha límite {{date}}. Revise si está al día o exento.",
    "card_UPLOAD_DOCUMENTS": "Alguien en su hogar tiene requisitos de trabajo de Medicaid con fecha límite {{date}}. Suba documentos para mantenerse al día.",
    "caseNumbers": {
      "description": "Usaremos estos números de caso para hacer los envíos de su hogar.",
      "descriptionSingle": "Usaremos este número de caso para enviar los documentos de trabajo de {{name}}.",
      "hint": "Búsquelos en el correo de su agencia estatal sobre su cobertura.",
      "hintSingle": "Búsquelo en el correo de la agencia estatal sobre la cobertura de {{name}}.",
      "memberLabel": "{{name}}",
      "title": "Agreguemos los números de caso de su hogar (opcional)",
      "titleSingle": "Agreguemos el número de caso de {{name}} (opcional)"
    },
    "confirmation": {
      "completedDescription": "Nuestro equipo lo revisará y se comunicará con usted si necesitamos algo.",
      "completedTitle": "Felicitaciones, completó los <label>requisitos de trabajo</label>",
      "description": "Por favor, recuerde completar sus requisitos antes de su renovación del {{date}}.",
      "title": "Los <label>requisitos de trabajo</label> están en proceso",
      "uploadsHint": "Puede terminar de subir documentos desde el inicio cuando se abran más meses."
    },
    "due": "Fecha límite <bold>{{date}}</bold>",
    "exemptions": {
      "description": "Elija todas las que correspondan",
      "groups": {
        "BENEFITS_AND_COVERAGE": "Beneficios y cobertura",
        "CAREGIVING": "Cuidado de otras personas",
        "HEALTH_AND_RECOVERY": "Salud y recuperación",
        "LIFE_SITUATIONS": "Situaciones de vida"
      },
      "options": {
        "CAREGIVER_OF_CHILD_13_OR_YOUNGER": "Padre, madre o cuidador de un niño de 13 años o menos",
        "CAREGIVER_OF_PERSON_WITH_DISABILITY": "Cuidador de una persona con discapacidad",
        "FOSTER_YOUTH_UNDER_26": "Joven que está o estuvo en cuidado de crianza (foster care), menor de 26 años",
        "INCARCERATED_OR_RELEASED_LAST_90_DAYS": "En la cárcel o prisión, o salió en los últimos 90 días",
        "IN_DRUG_OR_ALCOHOL_TREATMENT": "En un programa de tratamiento para drogas o alcohol",
        "MEDICALLY_FRAIL": "Médicamente frágil",
        "MEETING_SNAP_TANF_WORK_REQUIREMENTS": "Ya cumple los requisitos de trabajo de SNAP/TANF",
        "NOT_ENROLLED_OR_ELIGIBLE_FOR_MEDICARE": "No inscrito en Medicare ni elegible para Medicare",
        "PREGNANT_OR_POSTPARTUM": "Embarazada o en posparto (12 meses o menos)",
        "TRIBAL_MEMBER": "Miembro de una tribu nativa americana reconocida a nivel federal",
        "VETERAN_100_PERCENT_DISABILITY": "Veterano con una calificación de discapacidad total (100%)"
      },
      "title": "¿Aplica alguna de estas exenciones?"
    },
    "hours": {
      "communityService": "Servicio comunitario",
      "description_completed": "Agregue las horas completadas de {{name}} en {{month}}. Déjelo en blanco si no tiene.",
      "description_expected": "Agregue las horas esperadas de {{name}} para {{month}}. Déjelo en blanco si no tiene.",
      "employment": "Empleo",
      "employmentHint": "Escriba las horas y el pago mensual. Convertiremos el pago en horas y contaremos la cantidad más alta para el requisito.",
      "hoursPerMonth": "horas / mes",
      "jobTraining": "Capacitación laboral",
      "payPerMonth": "$ / mes",
      "school": "Escuela / programa de aprendiz",
      "title": "Reportar horas de {{name}}",
      "totalHours": "Total de horas",
      "totalOf": "<bold>{{total}}</bold> / {{required}}"
    },
    "income": {
      "description": "Elija a todas las personas que correspondan, o continúe si no hay ninguna.",
      "everyone": "Todas estas personas",
      "title": "¿Quién gana ${{amount}} o más al mes?",
      "titleSingle": "¿{{name}} gana ${{amount}} o más al mes?"
    },
    "medicaidWorkRequirements": "Requisitos de trabajo de Medicaid",
    "nextSteps": {
      "complete": "{{completed}} de {{total}} completados",
      "description": "Esto es lo que cada persona necesita enviar para mantener su cobertura.",
      "needsMoreHours": "Necesita {{hours}} horas más / mes",
      "offrampDescription": "Para mantener la cobertura de salud, se deben completar {{hours}} horas de actividades aprobadas al mes. Esto puede incluir empleo, capacitación laboral, escuela, programa de aprendiz o servicio comunitario.",
      "opensOn": "Se abre el {{date}}",
      "proofOfExemption": "Prueba de exención",
      "proofOfWork": "Prueba de trabajo ({{month}})",
      "reasonHours": "Reportó {{hours}} horas / mes",
      "reasonIncome": "Gana ${{amount}} o más al mes",
      "reportedOf": "Reportó {{hours}} de {{required}} horas / mes",
      "status_EXEMPT": "Exento",
      "status_MEETS_REQUIREMENTS": "Cumple los requisitos",
      "title": "<label>Requisitos de trabajo</label>: próximos pasos",
      "volunteerOpportunities": "Oportunidades de voluntariado"
    },
    "noWorkRequirements": "No hay requisitos de trabajo para su hogar.",
    "progress_ACTION_NEEDED": "Se necesita acción",
    "progress_COMPLETED": "Completado",
    "progress_UP_TO_DATE": "Al día",
    "recheck": "Volver a revisar requisitos de trabajo",
    "sectionTitle": "Requisitos de trabajo",
    "whatAreDescription": "Una nueva ley federal pide que ciertos adultos con Medicaid trabajen, se capaciten para un empleo, estudien o hagan voluntariado {{hours}} horas al mes. Esto solo aplica a adultos de {{minAge}} a {{maxAge}} años.",
    "who": {
      "checkAll": "Revisar a todos los miembros del hogar",
      "noEligibleMembers": "Nadie en su hogar tiene entre {{minAge}} y {{maxAge}} años, así que no hace falta revisar a nadie.",
      "question": "<bold>¿A quién quiere revisar? Veremos si están al día o exentos y le apoyaremos desde ahí.</bold>",
      "title": "Revisar el estado de <label>requisitos de trabajo</label> del hogar"
    }
  }
}
